export enum ContractorField {
  CICPA_ID = "CicpaId",
  TRADE_LICENSE_EXPIRY = "TradeLicenseExpiryDate",
  TRADE_LICENSE = "TradeLicense",
  TRADE_LICENSE_FILE_NAME = "TradeLicenseFileName",
  TRADE_LICENSE_FILE_FORMAT = "TradeLicenseFileFormat",
  TRADE_LICENSE_DOCTYPE_ID = "DocTypeId",
  CONTRACTOR_ARABIC_NAME = "ContractorArabicName",
}

export enum ContractorFieldLabel {
  CICPA_ID = "CICPA ID",
  TRADE_LICENSE_EXPIRY = "Trade license expiry date",
  TRADE_LICENSE = "Trade License",
}

export enum ContractorFieldSubLabel {
  ARABIC_NAME = "Please enter the Arabic name manually and avoid copy/paste",
}
